export default __webpack_public_path__ + "static/media/mern.aa071a63.jpg";